import { AvailabilityInfo } from '@/hooks/useAvailabilityInfo';

// eslint-disable-next-line no-shadow
export enum EventTypes {
    booking = 'booking',
    invalidCheckinDay = 'invalidCheckinDay',
    minimumRentalDuration = 'minimumRentalDuration',
    select = 'select',
    expired = 'expired',
}

type WeekdayName = 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday';
const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export const getDayIndexFromWeekdayName = (weekdayName: WeekdayName): number => {
    const dayIndex = days.indexOf(weekdayName.toLowerCase());

    return dayIndex;
};

export const getIsInvalidCheckinDay = ({ availabilityInfo, date }: { availabilityInfo?: AvailabilityInfo; date: Date }): boolean => {
    if (!availabilityInfo?.availabilityList) {
        return false;
    }

    const invalidCheckinDayList = availabilityInfo.availabilityList.filter((checkinDay) => checkinDay.checkinDay === false) ?? [];
    const invalidCheckinDayIndexList: number[] = invalidCheckinDayList.map((checkinDay) => getDayIndexFromWeekdayName(checkinDay.day));

    return invalidCheckinDayIndexList.includes(date.getDay());
};

export const isDateEqual = (date1: Date, date2: Date): boolean =>
    date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
